export default __webpack_public_path__ + "static/media/icon_e.c4dd0ba7.svg";